/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where do I get the molecular weight?`)
};

const es_massmol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde consigo el peso molecular?`)
};

const de_massmol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woher bekomme ich das Molekulargewicht?`)
};

const nl_massmol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar vind ik het molecuulgewicht?`)
};

const fr_massmol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où trouver la masse moléculaire ?`)
};

const it_massmol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove trovo il peso molecolare?`)
};

const pt_br2_massmol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde encontro o peso molecular?`)
};

const pt_massmol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde encontro a massa molecular?`)
};

const ja_massmol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分子量はどこで確認できますか？`)
};

const zh_massmol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从哪里获取分子量？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_faq_q2", locale)
	if (locale === "en") return en_massmol_faq_q2(inputs)
	if (locale === "es") return es_massmol_faq_q2(inputs)
	if (locale === "de") return de_massmol_faq_q2(inputs)
	if (locale === "nl") return nl_massmol_faq_q2(inputs)
	if (locale === "fr") return fr_massmol_faq_q2(inputs)
	if (locale === "it") return it_massmol_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_faq_q2(inputs)
	if (locale === "pt") return pt_massmol_faq_q2(inputs)
	if (locale === "ja") return ja_massmol_faq_q2(inputs)
	return zh_massmol_faq_q2(inputs)
};